var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "VShow"
  }, [_c("div", {
    staticClass: "subTitle"
  }, [_vm._v("案例图示 "), _c("img", {
    class: {
      down: _vm.isShow
    },
    attrs: {
      src: require("@/assets/images/service/openAI/arrow-up.png")
    },
    on: {
      click: _vm.clickImg
    }
  })]), _vm.isShow ? _c("ol", {
    staticClass: "screenshot"
  }, [_c("viewer", {
    staticClass: "pre-view",
    attrs: {
      images: _vm.interfaceDetail.interface_pictures
    }
  }, _vm._l(_vm.interfaceDetail.interface_pictures, function (item) {
    return _c("li", {
      key: item
    }, [_c("div", {
      staticClass: "mask-con"
    }, [_c("img", {
      staticClass: "aa",
      attrs: {
        src: item,
        alt: "screenshot"
      }
    })])]);
  }), 0)], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };